export default "__VITE_ASSET__gBUplYxN__"